import type { RouteObject } from "react-router";

/**
 * Auth routes, split by who may see them:
 *  - `guestAuthRoutes` are wrapped in <RequireGuest/> (a signed-in user is sent
 *    to the app instead of being offered a second login),
 *  - `openAuthRoutes` must work in both states: confirming an e-mail or
 *    accepting an invitation happens just as often while already signed in.
 */
export const guestAuthRoutes: RouteObject[] = [
  { path: "login", lazy: () => import("./pages/login") },
  { path: "signup", lazy: () => import("./pages/signup") },
  { path: "forgot-password", lazy: () => import("./pages/forgot-password") },
  { path: "reset-password", lazy: () => import("./pages/reset-password") },
];

export const openAuthRoutes: RouteObject[] = [
  { path: "verify-email", lazy: () => import("./pages/verify-email") },
  // `/accept-invite?token=` is the link every invitation e-mail carries
  // (auth/tokens.ts, org/workspace.ts), the owner invitation of a workspace
  // Lean2Automate provisions included; the other two are older spellings.
  { path: "accept-invite", lazy: () => import("./pages/accept-invitation") },
  { path: "accept-invitation", lazy: () => import("./pages/accept-invitation") },
  { path: "invite/:token", lazy: () => import("./pages/accept-invitation") },
];
